var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleFillX = function SvgCircleFillX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5858 12L8.29093 9.70514C7.9004 9.31462 7.9004 8.68145 8.29093 8.29093C8.68145 7.9004 9.31462 7.9004 9.70514 8.29093L12 10.5858L14.2987 8.28707C14.6892 7.89655 15.3224 7.89655 15.7129 8.28707C16.1035 8.6776 16.1035 9.31076 15.7129 9.70129L13.4142 12L15.7065 14.2923C16.097 14.6828 16.097 15.316 15.7065 15.7065C15.316 16.097 14.6828 16.097 14.2923 15.7065L12 13.4142L9.7068 15.7074C9.31628 16.0979 8.68312 16.0979 8.29259 15.7074C7.90207 15.3169 7.90207 14.6837 8.29259 14.2932L10.5858 12ZM12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23Z",
    fill: "#767676"
  })));
};
export default SvgCircleFillX;